export default {
  preMerit: {},
  postMerit: {},
  isLoadingMerit: true,
  metadata: {},
  meritError: null,
  calculatingMerit: false,
  previous: {},
};
